// extracted by mini-css-extract-plugin
export default {"card":"Card_card__U9gjD","btn":"Card_btn__q9aJU","link":"Card_link__t6UKO","text-light":"Card_text-light__jMQ+B","image":"Card_image__JVYiR","text":"Card_text__CNkFA"};